import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LinearLoader } from "../../components/Loader/LinearLoader";
import { getNerveClaims } from "../../redux/admin/actions/admin.actions";
import { SyncOutlined } from "@ant-design/icons";
import { sendClaimDetails } from "../../redux/admin/actions/admin.actions";
import { Table } from "react-bootstrap";
import style from "./NerveClaims.module.scss";

const NerveClaims = () => {
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [dataItem, setDataItem] = useState({});
  const dispatch = useDispatch();
  const { nerveClaims } = useSelector((state) => state.adminReducer);
  let userDetails;
  if (localStorage.getItem("userDetails")) {
    userDetails = JSON.parse(localStorage.getItem("userDetails"));
  }
  const user_id = userDetails.data.id;

  const handleRow = (item) => {
    const { id } = item;
    const formData = {
      id: id,
      user_id: user_id,
    };
    setDataItem(formData);
    setModal(true);
    // dispatch(sendClaimDetails(formData));
  };

  useEffect(() => {
    setLoading(true);
    dispatch(getNerveClaims());
    setLoading(false);
  }, [dispatch]);

  const headers = [
    { key: "Id", label: "Id" },
    { key: "name", label: "Name" },
    { key: "email", label: "Email" },
    { key: "Phone", label: "Phone" },

    { key: "Claim", label: "" },
  ];
  return (
    <div>
      <h2 className={style.Heading}>Nerve Account Verify</h2>
      <section style={{ maxWidth: "90%", margin: "auto", padding: "10px" }}>
        {loading && <LinearLoader />}

        <Table borderless responsive className="mt-4">
          <thead>
            <tr className={style.TableHeadRow}>
              {headers.map((row) => {
                return <td key={row.key}>{row.label} </td>;
              })}
            </tr>
          </thead>
          {nerveClaims?.map((item, index) => {
            return (
              <tbody>
                <tr className={style.TableBodyRow} key={index}>
                  <td
                    style={{
                      width: "7vw",
                      verticalAlign: "middle",
                      padding: "10px",
                    }}
                  >
                    {item?.id}
                  </td>
                  <td
                    style={{
                      width: "12vw",
                      verticalAlign: "middle",
                      padding: "10px",
                    }}
                  >
                    {item?.name}
                  </td>
                  <td
                    style={{
                      width: "20vw",
                      verticalAlign: "middle",
                      padding: "10px",
                    }}
                  >
                    {item?.email}
                  </td>
                  <td
                    style={{
                      width: "12vw",
                      verticalAlign: "middle",
                      padding: "10px",
                    }}
                  >
                    {item?.phone}
                  </td>

                  <td style={{ width: "15vw" }}>
                    <button
                      className={`${style.btn}`}
                      onClick={() => handleRow(item)}
                    >
                      Process
                    </button>
                  </td>
                </tr>
              </tbody>
            );
          })}
        </Table>
        {modal && <Modal setModal={setModal} dataItem={dataItem} />}
      </section>
    </div>
  );
};

export default NerveClaims;

const Modal = ({ setModal, dataItem }) => {
  const dispatch = useDispatch();

  const [showSpinner, setShowSpinner] = useState(false);

  const handleYesButton = () => {
    dispatch(sendClaimDetails(dataItem));

    setShowSpinner(true);
    setTimeout(() => {
      setShowSpinner(false);
      setModal(false);
    }, 1500);
  };
  const handleNoButton = () => {
    setModal(false);
  };
  const handleOverlayClick = () => {
    // setModal(false);
  };
  return (
    <div className={style.overlay} onClick={handleOverlayClick}>
      <div className={style.modalContent}>
        <h4 className={style.headerModal}>Have you verified the hospital’s most recent order history (last 3 orders)?</h4>
        <div className={style.btnContainer}>
          <button className={style.btn} onClick={handleYesButton}>
            {showSpinner ? <SyncOutlined spin /> : "Yes"}
          </button>
          <button className={style.btn} onClick={handleNoButton}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};
